'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import styles from './styles/StockNavigation.module.css';
import { cn } from '@/lib/utils';

interface NavItem {
  title: string;
  href: string;
  badge?: number;
}

const navItems: NavItem[] = [
  // { title: 'Price Chart', href: 'summary', badge: 1 },
  // { title: 'Fundamentals', href: 'fundamentals', badge: 2 },
  { title: 'Summary', href: 'summary', badge: 1 },
  { title: 'Latest News', href: 'news', badge: 2 },
  // { title: 'Announcements', href: 'announcements', badge: 3 },
  { title: 'Sector Comparison', href: 'comparison', badge: 4 },
  { title: 'Earnings Report', href: 'earnings', badge: 4 },
  { title: 'Revenue & Growth', href: 'revenues', badge: 5 },
  { title: 'Peers', href: 'peers', badge: 5 },
  { title: 'Income Statement', href: 'income-statement', badge: 6 },
  { title: 'Balance Sheet', href: 'balance-sheet', badge: 7 },
  { title: 'Cash Flow', href: 'cash-flow', badge: 8 },
];

export function StockNavigation() {
  const [activeSection, setActiveSection] = useState('summary');

  useEffect(() => {
    // Set up intersection observers for each section
    const observers: IntersectionObserver[] = [];
    const options = {
      root: null, // viewport
      rootMargin: '-80px 0px -20% 0px', // Adjust top margin to account for sticky header
      threshold: 0.1, // 10% of the element visible
    };

    // Create an observer for each section
    navItems.forEach(item => {
      const element = document.getElementById(item.href);
      if (!element) return;

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveSection(item.href);
          }
        });
      }, options);

      observer.observe(element);
      observers.push(observer);
    });

    // Clean up observers on unmount
    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <nav className={styles.navTabs}>
      <div className={styles.navTabsContainer}>
        {navItems.map((item) => (
          <Link
            key={item.href}
            href={`#${item.href}`}
            className={cn(
              styles.tabLink,
              activeSection === item.href && styles.activeTabLink
            )}
            onClick={() => setActiveSection(item.href)}
            prefetch={false}
          >
            {item.title}
          </Link>
        ))}
      </div>
    </nav>
  );
}